import {
  endOfMonth,
  isFriday,
  isMonday,
  isSaturday,
  isSunday,
  nextMonday,
  previousFriday,
  previousMonday,
} from 'date-fns'

const getStartOfDisplayedDateRangeByYearAndMonth = (year: number, month: number): Date => {
  const dateWithDisplayedMonthAndYear = new Date(year, month)

  if (isMonday(dateWithDisplayedMonthAndYear)) {
    return dateWithDisplayedMonthAndYear
  }
  if (isSaturday(dateWithDisplayedMonthAndYear) || isSunday(dateWithDisplayedMonthAndYear)) {
    return nextMonday(dateWithDisplayedMonthAndYear)
  }
  return previousMonday(dateWithDisplayedMonthAndYear)
}

const getEndOfDisplayedDateRangeByYearAndMonth = (year: number, month: number): Date => {
  const dateWithDisplayedMonthAndYear = new Date(year, month)
  const displayedMonthEndDate = endOfMonth(dateWithDisplayedMonthAndYear)

  if (isFriday(displayedMonthEndDate)) {
    return displayedMonthEndDate
  }

  return previousFriday(displayedMonthEndDate)
}

export const getDisplayedDateRangeByDate = (date: Date): [Date, Date] => {
  const year = date.getFullYear()
  const month = date.getMonth()
  const fromDate = getStartOfDisplayedDateRangeByYearAndMonth(year, month)
  const toDate = getEndOfDisplayedDateRangeByYearAndMonth(year, month)

  return [fromDate, toDate]
}
